import { useBreakpoint } from './BreakpointProvider';
/**
 * @component Breakpoint
 * @since 1.0.0
 */
export function Breakpoint(props) {
    const { isAbove, isBelow, isAboveOrEqual, isBelowOrEqual } = props;
    const breakpoint = useBreakpoint();
    let match = false;
    if (match == false && isAbove)
        match = breakpoint.isAbove(isAbove);
    if (match == false && isBelow)
        match = breakpoint.isBelow(isBelow);
    if (match == false && isAboveOrEqual)
        match = breakpoint.isAboveOrEqual(isAboveOrEqual);
    if (match == false && isBelowOrEqual)
        match = breakpoint.isBelowOrEqual(isBelowOrEqual);
    return match ? props.children : null;
}
